module.exports = __webpack_public_path__ + "assets/img/17_1426.5cfe30a9.jpg";